import { motion } from "framer-motion";
import { useMemo } from "react";

/**
 * Confetti — a one-shot celebratory confetti burst for winner overlays.
 * Denser and longer than GrandFinale's confetti.
 * Duration ~3s, ~90 pieces, drops with gravity + rotation.
 */
export default function Confetti({ count = 90 }) {
  const pieces = useMemo(() => {
    const colors = [
      "#fbbf24",
      "#f59e0b",
      "#fde68a",
      "#ffffff",
      "#f97316",
      "#a78bfa",
      "#22d3ee",
    ];
    return Array.from({ length: count }, (_, i) => {
      const angle = Math.random() * 360;
      const dist = 260 + Math.random() * 520;
      const rad = (angle * Math.PI) / 180;
      const x = Math.cos(rad) * dist;
      const y = Math.sin(rad) * dist;
      return {
        i,
        x,
        y: y + 180 + Math.random() * 260,
        w: 6 + Math.random() * 10,
        h: 10 + Math.random() * 14,
        rotate: 360 + Math.random() * 720,
        color: colors[i % colors.length],
        delay: Math.random() * 0.25,
        dur: 2.2 + Math.random() * 0.6,
      };
    });
  }, [count]);

  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none flex items-center justify-center"
    >
      {pieces.map((p) => (
        <motion.span
          key={p.i}
          initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 0.4 }}
          animate={{
            x: p.x,
            y: p.y,
            opacity: [1, 1, 0],
            rotate: p.rotate,
            scale: 1,
          }}
          transition={{ duration: p.dur, delay: p.delay, ease: "easeOut" }}
          className="absolute"
          style={{
            width: p.w,
            height: p.h,
            background: p.color,
            boxShadow: `0 0 8px ${p.color}`,
            borderRadius: 2,
          }}
        />
      ))}
    </div>
  );
}
